import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_inventory_summary_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { ownerId?: number, projectId?: number, warehouseId?: number[], fullTextSearch?: string, take?: number, skip?: number, materialIds?: number[] }): 
  Promise<{ result: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Warehouse?: { Name?: string }, Material?: { Id?: number, Description?: string, LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string } }, Packaging?: { Name?: string, ShortName?: string }, material_availability?: { TotalAvailablePackagedAmount?: number, TotalAvailableBaseAmount?: number, TotalInactiveBaseAmount?: number, TotalInactivePackagedAmount?: number, TotalSoftAllocatedBaseAmount?: number, TotalSoftAllocatedPackagedAmount?: number, TotalIncomingBaseAmount?: number, TotalIncomingPackagedAmount?: number } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { ownerId?: number, projectId?: number, warehouseId?: number[], fullTextSearch?: string, take?: number, skip?: number, materialIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Warehouse?: { Name?: string }, Material?: { Id?: number, Description?: string, LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string } }, Packaging?: { Name?: string, ShortName?: string }, material_availability?: { TotalAvailablePackagedAmount?: number, TotalAvailableBaseAmount?: number, TotalInactiveBaseAmount?: number, TotalInactivePackagedAmount?: number, TotalSoftAllocatedBaseAmount?: number, TotalSoftAllocatedPackagedAmount?: number, TotalIncomingBaseAmount?: number, TotalIncomingPackagedAmount?: number } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { ownerId?: number, projectId?: number, warehouseId?: number[], fullTextSearch?: string, take?: number, skip?: number, materialIds?: number[], $keys: { WarehouseId?: number, MaterialId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Warehouse?: { Name?: string }, Material?: { Id?: number, Description?: string, LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string } }, Packaging?: { Name?: string, ShortName?: string }, material_availability?: { TotalAvailablePackagedAmount?: number, TotalAvailableBaseAmount?: number, TotalInactiveBaseAmount?: number, TotalInactivePackagedAmount?: number, TotalSoftAllocatedBaseAmount?: number, TotalSoftAllocatedPackagedAmount?: number, TotalIncomingBaseAmount?: number, TotalIncomingPackagedAmount?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      ownerId?: number, projectId?: number, warehouseId?: number[], fullTextSearch?: string, take?: number, skip?: number, materialIds?: number[]    }) {
      return false;
    }
}
